import { accountTypes } from './actionTypes'
import {
    ISettings,
    FetchSettingsRequest,
    EditSettingsPayload,
    EditSettingsRequest,
    SetSettings,
    FetchSettingsPayload,
} from './types'

export const fetchSettingsAction = (
    payload: FetchSettingsPayload,
): FetchSettingsRequest => ({
    type: accountTypes.FETCH_SETTINGS_REQUEST,
    payload,
})

export const editGroupAction = (
    payload: EditSettingsPayload,
): EditSettingsRequest => ({
    type: accountTypes.EDIT_SETTINGS_REQUEST,
    payload,
})

export const SetTeamAction = (payload: {
    settings: ISettings
}): SetSettings => ({
    type: accountTypes.SET_SETTINGS,
    payload,
})
